import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './InsertCorrectivo.css';
import { insertOrder, getTasksByMachine, getAllUsers } from '../general/api'; // Asegúrate de que la ruta al archivo api.js sea correcta
import { fetchOrders, fetchOrdersSuccess, selectSubMenu } from '../../actions';

const InsertCorrectivo = ({ navigationHistory, machine }) => {
    const dispatch = useDispatch();
    const machines = useSelector((state) => state.machine.machines);
    const user = useSelector((state) => state.auth.user);
    const orders = useSelector((state) => state.machine.orders);
    const [formData, setFormData] = useState({
        assignedUser: '',
        fecha: '',
        selectedMachine: machine ? machine.Id_Machine : '',
    });
    const [taskId, setTaskId] = useState(null);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchTaskId = async () => {
            try {
                const machineId = machine ? machine.Id_Machine : formData.selectedMachine;
                if (machineId) {
                    const tasks = await getTasksByMachine(machineId);
                    const task = tasks.find(t => t.Id_Task_Type === 6);
                    if (task) {
                        setTaskId(task.Id_Task);
                    }
                }
            } catch (error) {
                console.error('Error al obtener las tareas:', error);
            }
        };

        fetchTaskId();
    }, [machine, formData.selectedMachine]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await getAllUsers(user.Id_Empresa);
                setUsers(response);
            } catch (error) {
                console.error('Error al obtener los usuarios:', error);
            }
        };

        fetchUsers();
    }, [user.Id_Empresa]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const orderData = {
            id_task: taskId, // Obtenemos el id_task dinámicamente
            id_empresa: user.Id_Empresa,
            scheduled_date: formData.fecha,
            assigned_user: formData.assignedUser,
            priority: '100',
            status: 'Asignada' 
        };

        try {
            dispatch(selectSubMenu('maquinas'));
            dispatch(fetchOrders());
            const response = await insertOrder(orderData.id_task, orderData.id_empresa, orderData.scheduled_date, orderData.assigned_user, orderData.priority, orderData.status);
            dispatch(fetchOrdersSuccess(orders));
            alert(JSON.stringify(response));
            dispatch(selectSubMenu('ordenes'));
            
            
        } catch (error) {
            navigationHistory();
            alert('Error al insertar la orden:', error);
        }
    };

    return (
        <>
            <div className='InsertCorrectivo'>
                <h2>Generar Orden Para Mantenimiento Correctivo</h2>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>Usuario asignado:</label>
                        <select
                            name='assignedUser'
                            value={formData.assignedUser}
                            onChange={handleChange}
                            required
                        >
                            <option value=''>Selecciona un usuario</option>
                            {users.map((user) => (
                                <option key={user.Id_User} value={user.Id_User}>
                                    {`${user.Name_User} - ${user.Cc_User}`}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label>Programar Fecha:</label>
                        <input
                            type='date'
                            name='fecha'
                            value={formData.fecha}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {!machine && (
                        <div>
                            <label>Máquina:</label>
                            <select
                                name='selectedMachine'
                                value={formData.selectedMachine}
                                onChange={handleChange}
                                required
                            >
                                <option value=''>Selecciona una máquina</option>
                                {machines.map((m) => (
                                    <option key={m.Id_Machine} value={m.Id_Machine}>
                                        {m.Internall_Code_Machine}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <button type='button' onClick={navigationHistory}>Regresar</button>
                    <button type='submit'>Insertar</button>
                </form>
            </div>
        </>
    );
};

export default InsertCorrectivo;
